import {
    CLEAR_SELECTED_CONVERSATION,
    CLOSE_FORWARD_DIALOG, DELETE_CHAT_DRAFT_MESSAGES,
    DELETE_CHAT_MESSAGE,
    DESTROY_CHAT,
    EDIT_CHAT_MESSAGE,
    END_CONVERSATION_FAILED,
    END_CONVERSATION_FOR_OPERATOR_REQUESTED,
    END_CONVERSATION_REQUESTED,
    END_CONVERSATION_SUCCEEDED,
    FORWARD_CONVERSATION_FAILED,
    FORWARD_CONVERSATION_REQUESTED,
    FORWARD_CONVERSATION_SUCCEEDED,
    HANDLE_NOT_SENT_MESSAGE,
    INIT_CHAT_FAILED,
    INIT_CHAT_REQUESTED,
    INIT_CHAT_SUCCEEDED, INSERT_CHAT_DRAFT_MESSAGE,
    INSERT_CHAT_MESSAGE,
    INSERT_CONVERSATION,
    LOAD_OLDER_MESSAGES_FAILED,
    LOAD_OLDER_MESSAGES_REQUESTED,
    LOAD_OLDER_MESSAGES_SUCCEEDED,
    OPEN_FORWARD_DIALOG,
    REMOVE_CONVERSATION,
    SELECT_CONVERSATION_FAILED,
    SELECT_CONVERSATION_REQUESTED,
    SELECT_CONVERSATION_SUCCEEDED,
    SEND_CHAT_MESSAGE_FAILED,
    SEND_CHAT_MESSAGE_REQUESTED,
    SEND_CHAT_MESSAGE_SUCCEEDED,
    SEND_CHAT_REACTION_REQUESTED,
    SET_CONVERSATIONS_LIST,
    UPDATE_CHAT_MESSAGE_REACTIONS,
    UPDATE_CONVERSATION,
    UPDATE_SELECTED_CONVERSATION,
    USER_TYPING_START,
    USER_TYPING_STOP
} from './actionTypes';


export function userTypingStart(conversationId) {
    return {
        type: USER_TYPING_START,
        payload: {
            conversationId,
        },
    };
}

export function userTypingStop(conversationId) {
    return {
        type: USER_TYPING_STOP,
        payload: {
            conversationId,
        },
    };
}

export function initChatRequested() {
    return {
        type: INIT_CHAT_REQUESTED,
    };
}

export function initChatSucceeded() {
    return {
        type: INIT_CHAT_SUCCEEDED,
    };
}

export function initChatFailed() {
    return {
        type: INIT_CHAT_FAILED,
    };
}

export function setConversationsList(conversationsList) {
    return {
        type: SET_CONVERSATIONS_LIST,
        payload: {
            conversationsList,
        },
    };
}

export function updateConversation(id, update) {
    return {
        type: UPDATE_CONVERSATION,
        payload: {
            id,
            update,
        },
    };
}

export function insertConversation(conversation) {
    return {
        type: INSERT_CONVERSATION,
        payload: {
            conversation,
        },
    };
}

export function removeConversation(id) {
    return {
        type: REMOVE_CONVERSATION,
        payload: {
            id,
        },
    };
}


export function selectConversationRequested(conversation, silentMode = false, withTake = true) {
    return {
        type: SELECT_CONVERSATION_REQUESTED,
        payload: {
            conversation,
            silentMode,
            withTake
        },
    };
}

export function selectConversationSucceeded(conversation, messages, messagesTotalNumber) {
    return {
        type: SELECT_CONVERSATION_SUCCEEDED,
        payload: {
            conversation,
            messages,
            messagesTotalNumber,
        },
    };
}

export function selectConversationFailed() {
    return {
        type: SELECT_CONVERSATION_FAILED,
        payload: {},
    };
}


export function insertChatMessage(message) {
    return {
        type: INSERT_CHAT_MESSAGE,
        payload: {
            message,
        },
    };
}

export function insertChatDraftMessage(message) {
    return {
        type: INSERT_CHAT_DRAFT_MESSAGE,
        payload: {
            message,
        },
    };
}

export function deleteChatMessage(message) {
    return {
        type: DELETE_CHAT_MESSAGE,
        payload: {
            message,
        },
    };
}

export function deleteChatDraftMessages() {
    return {
        type: DELETE_CHAT_DRAFT_MESSAGES,
        payload: {},
    };
}

export function editChatMessage(message) {
    return {
        type: EDIT_CHAT_MESSAGE,
        payload: {
            message,
        },
    };
}

export function handleNotSentMessage(message) {
    return {
        type: HANDLE_NOT_SENT_MESSAGE,
        payload: {
            message,
        },
    };
}

export function sendChatMessageRequested(message, commentMessage) {
    return {
        type: SEND_CHAT_MESSAGE_REQUESTED,
        payload: {
            message,
            commentMessage
        },
    };
}

export function sendChatMessageSucceeded() {
    return {
        type: SEND_CHAT_MESSAGE_SUCCEEDED,
    };
}

export function sendChatMessageFailed() {
    return {
        type: SEND_CHAT_MESSAGE_FAILED,
    };
}

export function sendChatReactionRequested(message, reaction) {
    return {
        type: SEND_CHAT_REACTION_REQUESTED,
        payload: {
            message,
            reaction,
        },
    };
}

export function updateMessageReactions(message, reactions) {
    return {
        type: UPDATE_CHAT_MESSAGE_REACTIONS,
        payload: {
            message,
            reactions,
        },
    };
}

export function endConversationRequested() {
    return {
        type: END_CONVERSATION_REQUESTED,
    };
}

export function endConversationForOperatorRequested(silentMode, conv, details) {
    return {
        type: END_CONVERSATION_FOR_OPERATOR_REQUESTED,
        silentMode: silentMode,
        conv: conv,
        details: details
    };
}

export function endConversationSucceeded(contact) {
    return {
        type: END_CONVERSATION_SUCCEEDED,
        payload: {
            contact,
        },
    };
}

export function endConversationFailed() {
    return {
        type: END_CONVERSATION_FAILED,
    };
}

export function openForwardDialog() {
    return {
        type: OPEN_FORWARD_DIALOG,
    };
}

export function closeForwardDialog() {
    return {
        type: CLOSE_FORWARD_DIALOG,
    };
}

export function forwardConversationRequested(operatorContact, silentMode, conv) {
    return {
        type: FORWARD_CONVERSATION_REQUESTED,
        silentMode: silentMode,
        conv: conv,
        payload: {
            operatorContact,
        },
    };
}

export function forwardConversationSucceeded() {
    return {
        type: FORWARD_CONVERSATION_SUCCEEDED,
    };
}

export function forwardConversationFailed() {
    return {
        type: FORWARD_CONVERSATION_FAILED,
    };
}

export function updateSelectedConversation(updateData) {
    return {
        type: UPDATE_SELECTED_CONVERSATION,
        payload: updateData,
    };
}

export function loadOlderMessagesRequested() {
    return {
        type: LOAD_OLDER_MESSAGES_REQUESTED,
        payload: {},
    };
}

export function loadOlderMessagesSucceeded(messages) {
    return {
        type: LOAD_OLDER_MESSAGES_SUCCEEDED,
        payload: {
            messages,
        },
    };
}

export function loadOlderMessagesFailed() {
    return {
        type: LOAD_OLDER_MESSAGES_FAILED,
        payload: {},
    };
}

export function clearSelectedConversation() {
    return {
        type: CLEAR_SELECTED_CONVERSATION,
    };
}

export function destroyChat() {
    return {
        type: DESTROY_CHAT,
    };
}



// WEBPACK FOOTER //
// ./src/services/chat/action.js